import styled from 'styled-components';

export const Container = styled.div`
  .title {
    font-weight: bold;
    display: block;
    margin-bottom: 10px;

    @media screen and (min-width: 992px) {
      margin-bottom: 20px;
    }
  }

  .links {
    display: flex;
    flex-direction: ${({ isHorizontal }) => (isHorizontal ? 'row' : 'column')};

    .item {
      margin-bottom: ${({ isHorizontal }) => (isHorizontal ? '0' : '6px')};
      margin-right: ${({ isHorizontal }) => (isHorizontal ? '30px' : '0')};
      display: block;
      cursor: pointer;
      font-size: 0.875rem;

      &:hover {
        font-weight: bold;
      }

      &:last-child {
        margin-bottom: 0;
        margin-right: 0;
      }
    }
  }
`;
